import m11 from '../assets/machines/machine1/m11.webp';
import m12 from '../assets/machines/machine1/m12.webp';
import m13 from '../assets/machines/machine1/m13.webp';
import m14 from '../assets/machines/machine1/m14.webp';
export const machines = [
    {
        name: 'CV-line Machine for Medium Voltage Cables',
        image: [m11, m12, m13, m14],
    }
];